import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import { BootstrapVue } from 'bootstrap-vue'
Vue.use(BootstrapVue)

import { library } from '@fortawesome/fontawesome-svg-core'
import { faGripVertical, faDice, faHeartBroken, faRedo, faStopwatch, faProcedures, faPencilAlt, faUser, 
	faUpload, faCloudDownloadAlt, faDownload, faCloudUploadAlt, faShare, faPrint, faCogs, faNewspaper,
	faChevronRight, faChevronDown, faPlay, faHistory, faSync, faSpinner, faLink, faSave,
	faRobot, faToolbox, faPaw, faLevelUpAlt, faCashRegister, faTrashAlt, faShoppingCart, faCloud} from '@fortawesome/free-solid-svg-icons'
import { faSquare, faCheckSquare } from '@fortawesome/free-regular-svg-icons'
import { faDropbox } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add( faGripVertical, faDice, faHeartBroken, faRedo, faStopwatch, faProcedures, faPencilAlt, faUser, 
	faUpload, faCloudDownloadAlt, faDownload, faCloudUploadAlt, faShare, faPrint, faCogs, faNewspaper, 
	faChevronRight, faChevronDown, faPlay, faHistory, faSync, faSpinner, faLink, faSave, 
	faRobot, faToolbox, faPaw, faLevelUpAlt, faCashRegister, faTrashAlt, faShoppingCart, faCloud,
	faSquare, faCheckSquare, 
	faDropbox)
Vue.component('font-awesome-icon', FontAwesomeIcon)

import ExpandingTextarea from './components/ExpandingTextarea.vue'
Vue.component('expanding-textarea', ExpandingTextarea)

Vue.config.productionTip = false

Vue.filter('int', function(value){
	return parseInt(value);
})
Vue.filter('bonus', function(value){
	return (value >=0 ? '+' : '') + value;
})
Vue.filter('abbr', function(value){
	return value.substring(0,3).toUpperCase();
})
Vue.filter('d20roll', function(value){
	return "1d20" + (parseInt(value) >=0 ? '+' : '') + value;
})
Vue.filter('ordinal', function(value){
	switch(value){
		case "0":
			return "0";
		case "1":
			return "1st";
		case "2":
			return "2nd";
		case "3":
			return "3rd";
		default:
			return value+"th";
	}
})
Vue.filter('spaces', function(value){
	return value.split(' ').join('_');
})
Vue.filter('positivePad', function(value){
	var string = String( value )
	if(string.substring(0,1) !== '-'){
		return '\xa0' + string;
	}else{
		return string;
	}
})

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
